import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label, title, sub, testid }) => (
  <Reveal>
    <div data-testid={testid} className="max-w-3xl">
      <div className="flex items-center gap-4 mb-6">
        <span className="font-mono text-sm font-semibold tracking-[0.3em] text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-amber-400">{number}</span>
        <motion.span
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
          className="h-px w-12 origin-left bg-gradient-to-r from-violet-500/70 to-amber-500/70"
        />
        <span className="font-mono text-sm font-semibold uppercase tracking-[0.25em] text-slate-300">{label}</span>
      </div>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.06]">{title}</h2>
      {sub && <p className="mt-5 text-lg sm:text-xl text-slate-300 font-normal leading-relaxed">{sub}</p>}
    </div>
  </Reveal>
);

export const Section = ({ id, testid, children, className = "" }) => (
  <section id={id} data-testid={testid} className={`relative z-10 py-16 sm:py-32 ${className}`}>
    <div className="max-w-7xl mx-auto px-5 sm:px-8">{children}</div>
  </section>
);
